import { createFileRoute } from "@tanstack/react-router";
import { toAgentsRouteSearch } from "~/features/agents/agent-authoring-route";
import { m } from "~/lib/i18n";

export const Route = createFileRoute("/_app/agents")({
  head: () => ({
    meta: [
      { title: m.agents_page_meta_title() },
      { content: m.agents_page_meta_description(), name: "description" },
    ],
  }),
  validateSearch: toAgentsRouteSearch,
});
